import unwrapModel from 'scoreboard/components/unwrap-model'
import _ from 'lodash'
import moment from 'moment'

/**
 * Sorts the given notes with the most recently created notes first.
 * Since #21104, this does not consider replies or lastModified date
 */
function sortNotesNewestFirst(notes) {
	return _.sortBy(notes, note => {
		return -1 * moment(unwrapModel(note).created).unix()
	})
}

export default sortNotesNewestFirst

sortNotesNewestFirst.__filename__ = 'notes/sort-notes-newest-first.js'
